import stylesPass from "../../styles/Organisms/ToolTipPassword/pass";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";

function TooltipPassword() {
  return (
    <Tooltip
      title={
        <>
          <Typography
            style={{
              fontSize: "0.9rem",
              fontFamily: "Raleway, sans-serif ",
              fontWeight: 500,
            }}
          >
            La contraseña debe tener las siguientes características:
          </Typography>
          <Typography
            component="ul" style={{marginTop:"1rem"}}
          >
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Mínimo 8 caracteres.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Máximo 15 caracteres.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Al menos una letra mayúscula.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Al menos una letra minúscula.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Al menos un dígito.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>No espacios en blanco.</li>
            <li    style={{
              fontFamily: "Raleway, sans-serif",
              fontSize: "0.9rem",
              fontWeight: 300,
            }}>Al menos un carácter especial ej. $@$!%*?&</li>
          </Typography>
        </>
      }
      disableFocusListener={false}
      disableHoverListener={false}
      disableTouchListener={false}
      disablePortal={false} // asegura que use portal (render en body)
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "rgb(255, 244, 229)", // tu color personalizado
            color: "#000",
            fontSize: "0.9rem",
            borderRadius: "10px",
            padding: "10px 16px",
            maxWidth: 300,
          },
        },
      }}
      PopperProps={{
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              altAxis: true,
            },
          },
          {
            name: "offset",
            options: {
              offset: [0, 8],
            },
          },
          {
            name: "computeStyles",
            options: {
              adaptive: false,
            },
          },
        ],
        // aquí forzamos z-index si es necesario
        style: { zIndex: 20000},
      }}
      placement="right"
      arrow
    >
        <Warning style={{color:"rgba(231, 196, 81, 1)"}} fontSize="medium" />
    </Tooltip>
  );
}

export default TooltipPassword;
